import { apiCall } from "../../services/api-service.js";

export const getEnabledFieldApi = async (data) => {
  const response = await apiCall("POST", "get_fields", data);
  return response.data;
};

export const getVehicleScanDataApi = async (qrTag) => {
  const response = await apiCall("GET", `get_vehicle_details/${qrTag}`);
  return response;
};

export const getValidateScanDataApi = async (qrTag) => {
  const response = await apiCall("POST", "dock_scan", { code: qrTag });
  return response;
};

export const getDefaultGateApi = async (payload) => {
  const response = await apiCall("POST", "get_default_dock", payload);
  return response;
};
export const getDockListApi = async (params) => {
  const response = await apiCall("GET", `dock?${params}`);
  return response;
};

export const getDockViewApi = async (params) => {
  const response = await apiCall("GET", `dock/get/${params}`);
  return response;
};

export const getDockMasterViewApi = async (params) => {
  const response = await apiCall("GET", `dockmaster/get/${params}`);
  return response;
};

export const createDockApi = async (data) => {
  const response = await apiCall("POST", "dock", data);
  return response;
};

export const uploadDockAttachmentApi = async (data) => {
  const response = await apiCall("POST", "dock_updateattachment", data);
  return response;
};

export const dockOutApi = async (id, data) => {
  const response = await apiCall("POST", `dock/${id}/dockout`, data);
  return response;
};
export const getDockDelayApi = async (vehId) => {
  const response = await apiCall("GET", `dock_in_delay/${vehId}`);
  return response;
};
export const getDockStatusApi = async (dockId) => {
  const response = await apiCall("GET", `get_dock_status/${dockId}`);
  return response;
};


export const createDockReferenceApi = async (data) => {
  const response = await apiCall("POST", "dock_reference", data);
  return response;
};

export const viewDockReferenceApi = async (id) => {
  const response = await apiCall("GET", `dock_reference/${id}`);
  return response;
};

export const updateDockReferenceApi = async (id, data) => {
  const response = await apiCall("PUT", `dock_reference/${id}`, data);
  return response;
};

export const deleteDockReferenceApi = async (id, data) => {
  const response = await apiCall("DELETE", `dock_reference/${id}`, data);
  return response;
};

export const addDockReferenceAttachmentsApi = async (referenceId, attachment) => {
  const response = await apiCall("POST", `dock_reference/add_attachments/${referenceId}`, { attachment });
  return response;
};

export const removeDockReferenceAttachmentsApi = async (referenceId, attachmentId) => {
  const response = await apiCall("DELETE", `dock_reference/remove_attachments/${referenceId}`, {
    attachment_id: attachmentId,
  });
  return response;
};

export const getDockReferenceEmailsApi = async (params) => {
  const response = await apiCall("GET", `get_reference_emails?${params}`);
  return response;
};
